
import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { imgStoragePath } from '../../constants';
import { getGlobalCookie, setGlobalCookie, setGlobalTimeCookie, getLocalStorageInfo } from '../../utils';
import { appConfig } from '../../config';

const bannerEnv = {
    development: 'dev',
    staging: 'qa',
    uat: 'uat',
    production: 'prod',
}[process.env.REACT_APP_ENV];

export default function DeploymentMessage({ row, margin,onStatusChange }) {
   const [deploymentFlag, setDeploymentFlag] = useState(false)
    const [bannerData, setBannerData] = useState(null)

    useEffect(() => {
        onStatusChange && onStatusChange(!!(deploymentFlag && bannerData))
    }, [deploymentFlag, bannerData])

    const getInfo = () => {
        fetch(`https://sparta-aims.ams3.cdn.digitaloceanspaces.com/maintenance_banner/${bannerEnv}/info.json?timestamp=${new Date().getTime()}`)
            .then(res => res.json())
            .then(resp => {
                const dismissed = JSON.parse(getGlobalCookie('showBanner') || '{}')
                if ( resp?.for_console && (resp?.id !== dismissed?.console || !dismissed?.console) ) {
                    setDeploymentFlag(resp?.for_console)
                    setBannerData(resp)
                } else {
                    return
                }
            })
            .catch(() => { })
    }

    useEffect(() => {
        getInfo()
        //URL will be called in every 6 hours 
        const interval = setInterval(getInfo, (6 * 60 * 60 * 1000))
        return () => clearInterval(interval)
    }, [])

    const getClientData = () => {
        let oldCookie = JSON.parse(getGlobalCookie('showBanner'))
        let consoleCookie= {console:bannerData?.id}
        setGlobalCookie('showBanner', JSON.stringify({...oldCookie, ...consoleCookie}), 3)
    }
    let marginVal = margin
    return (
        <>
            {deploymentFlag && bannerData ?
                row ?
                    <Grid container spacing={0} style={margin ? { marginTop: marginVal } : null}>
                        <Grid item md="12">
                            <p className="deployment-info">
                                <span>
                                    {bannerData.message}
                                    {/* {' '}<span className="ai-chat-link" onClick={() => window.open(`${appConfig.domain.leaseRevamp}ai-chat`, '_blank')}>Click here</span> to get started. */}
                                </span>
                                <span >
                                    <img width="13" onClick={() => { setDeploymentFlag(false); getClientData() }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon" />
                                </span>
                            </p>
                        </Grid>
                    </Grid> :
                    <Grid item sm="12">
                        <p className="deployment-info">
                            <span>
                                {bannerData.message}
                                {/* {' '}<span className="ai-chat-link" onClick={() => window.open(`${appConfig.domain.leaseRevamp}ai-chat`, '_blank')}>Click here</span> to get started. */}
                            </span>
                            <span >
                                <img width="13" onClick={() => { setDeploymentFlag(false); getClientData() }} src={imgStoragePath + "toast_cross.png"} alt="Close Icon" />
                            </span>
                        </p>
                    </Grid> : null
            }
        </>
    )
}